declare const CdnBasePath; //Declared on window

export const ContentMediaPath = (CdnBasePath ? `${CdnBasePath}/scripts/ContentMedia/` : '/scripts/ContentMedia/');
export const ContentRecallImagePath = (CdnBasePath ? `${CdnBasePath}/scripts/ContentMedia/` : '/scripts/ContentMedia/');

export function ContentImagePath(file?:string):string {
    const path = `${ContentMediaPath}images/`;
    return file ? `${path}${file}` : path;
}

export function ContentArticleVideoPath(file?:string):string {
    const path = `${ContentMediaPath}articles/video/`;
    return file ? `${path}${file}` : path;
}

export function ContentArticleImagePath(file?:string):string {
    const path = `${ContentMediaPath}articles/images/`;
    return file ? `${path}${file}` : path;
}

export function ContentGalleryImagePath(file?:string):string {
    const path = `${ContentMediaPath}gallery/`;
    return file ? `${path}${file}` : path;
}

export function ContentTechVideoImagePath(file?:string):string {
    const path = `${ContentMediaPath}techVideos/`;
    return file ? `${path}${file}` : path;
}

export function NavMenuPath(file?:string):string {
    const basePath = CdnBasePath ? `${CdnBasePath}/scripts/nav-menu/` : '/scripts/nav-menu/';
    return file ? `${basePath}${file}` : basePath;
}
